module.exports = __webpack_public_path__ + "static/media/galaxys20.f3d5ddf0.png";